import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ServicesTab from './tabs/ServicesTab';
import CategoriesTab from './tabs/CategoriesTab';
import ProfessionalsTab from './tabs/ProfessionalsTab';
import './ServicesComponent.css';

type ServicesTabKey = 'services' | 'events' | 'categories' | 'professionals';

const ServicesComponent: React.FC = () => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState<ServicesTabKey>('services');

    return (
        <div className="services-page" data-cy="services-page">
            <div className="tab-menu">
                <button
                    className={`tab-button ${selectedTab === 'services' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('services')}
                    type="button"
                    data-cy="services-tab-services"
                >
                    {t('services.tabServices')}
                </button>
                <button
                    className={`tab-button ${selectedTab === 'events' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('events')}
                    type="button"
                    data-cy="services-tab-events"
                >
                    {t('services.tabEvents')}
                </button>
                <button
                    className={`tab-button ${selectedTab === 'categories' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('categories')}
                    type="button"
                    data-cy="services-tab-categories"
                >
                    {t('services.tabCategories')}
                </button>
                <button
                    className={`tab-button ${selectedTab === 'professionals' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('professionals')}
                    type="button"
                    data-cy="services-tab-professionals"
                >
                    {t('services.tabProfessionals')}
                </button>
            </div>


            <div className="tab-content">
                {selectedTab === 'services' && <ServicesTab kind="SERVICE" />}
                {selectedTab === 'events' && <ServicesTab kind="EVENT" />}
                {selectedTab === 'categories' && <CategoriesTab />}
                {selectedTab === 'professionals' && <ProfessionalsTab />}
            </div>
        </div>
    );
};

export default ServicesComponent;
